const doc = [({"da":({"js":({"admin":({"photo_sessions":({"bottom_bar":({"create_photo_session_groups_with_contacts_from_csv":"Opret fotosessionsgrupper og kontakter fra csv"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;